export default __webpack_public_path__ + "static/media/Gold-ingots.45de04f0.png";